import { createReducer, Action, on } from '@ngrx/store';
import { differenceBy } from 'lodash-es';

import { DatapointFieldListActions } from './datapoint-field-list.actions';
import { DatapointFieldListState } from './datapoint-field-list.state';
import { measureReducer } from '../../features/shared/utils/runtime-reducer-stats';
import { DatapointFieldActions } from '../datapoint-field/datapoint-field.actions';

export const initialState: DatapointFieldListState = {
  loading: false,
  sort: {
    active: 'displayName',
    direction: 'asc',
  },
};

const featureReducer = measureReducer(
  createReducer(
    initialState,
    on(
      DatapointFieldListActions.LoadDatapointFields,
      (state): DatapointFieldListState => ({ ...state, loading: true, error: undefined })
    ),
    on(
      DatapointFieldListActions.SetDatapointFieldActivity,
      DatapointFieldListActions.DeleteDatapointField,
      (state): DatapointFieldListState => ({ ...state, loading: true, error: undefined })
    ),
    on(
      DatapointFieldListActions.LoadDatapointFieldsSuccess,
      (state, action): DatapointFieldListState => ({
        ...state,
        loading: false,
        fields: [...differenceBy(state.fields, action.list, (f) => f.id), ...action.list],
      })
    ),
    on(DatapointFieldListActions.RefreshDatapointFieldSuccess, (state, action): DatapointFieldListState => {
      let added = false;

      const fields = state.fields.map((f) => {
        if (f.id === action.item.id) {
          added = true;
          return action.item;
        }

        return f;
      });

      if (!added) {
        fields.push(action.item);
      }

      return {
        ...state,
        fields,
      };
    }),
    on(
      DatapointFieldListActions.SetDatapointFieldActivitySuccess,
      (state, action): DatapointFieldListState => ({
        ...state,
        loading: false,
        fields: state.fields?.map((f) => (f.id === action.id ? { ...f, active: action.active } : f)) || [],
      })
    ),
    on(
      DatapointFieldListActions.DeleteDatapointFieldSuccess,
      (state, action): DatapointFieldListState => ({
        ...state,
        loading: false,
        fields: state.fields?.filter((f) => f.id !== action.id) || [],
      })
    ),
    on(
      DatapointFieldListActions.LoadDatapointFieldsFail,
      DatapointFieldListActions.SetDatapointFieldActivityFail,
      DatapointFieldListActions.DeleteDatapointFieldFail,
      (state, action): DatapointFieldListState => ({
        ...state,
        loading: false,
        error: action.error,
      })
    ),
    on(
      DatapointFieldListActions.SortDatapointField,
      (state, action): DatapointFieldListState => ({ ...state, sort: action.sort })
    ),
    on(
      DatapointFieldListActions.SearchDatapointField,
      (state, action): DatapointFieldListState => ({ ...state, search: action.search })
    ),
    on(
      DatapointFieldActions.UpdateDatapointField,
      (state, action): DatapointFieldListState => ({
        ...state,
        fields: state.fields.map((f) => (f.id === action.field.id ? action.field : f)),
      })
    ),
    on(
      DatapointFieldListActions.RemoveDatapointFieldFromList,
      (state, action): DatapointFieldListState => ({
        ...state,
        fields: state.fields?.filter((f) => f.id !== action.id) || [],
      })
    )
  )
);

export function reducer(state: DatapointFieldListState | undefined, action: Action) {
  return featureReducer(state, action);
}
